import React, { createContext } from 'react';
import http from '../utils/httpFacade';
import axios from 'axios';

export const OrderContext = createContext();

const OrderContextProvider = ({ children }) => {
  const getOrders = async (query = {}) => {
    try {
      return await http.get({ url: 'crowd-farmer/orders', query });
    } catch (error) {
      return error;
    }
  };

  const downloadPDF = async (id, pdfType, token) => {
    try {
      return await axios.get(
        `${process.env.REACT_APP_PDF_GEN_APP_URL}/crowd-farmer/orders/${id}/download?pdfType=${pdfType}`,
        {
          responseType: 'blob',
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );
    } catch (error) {
      return error;
    }
  };

  const deleteOrder = async id => {
    try {
      return await http.delete({ url: `crowd-farmer/orders/${id}` });
    } catch (error) {
      return error;
    }
  };

  return (
    <OrderContext.Provider value={{ getOrders, downloadPDF, deleteOrder }}>
      {children}
    </OrderContext.Provider>
  );
};

export default OrderContextProvider;
